/* eslint-disable no-unused-vars */
import { useEffect, useState, useRef } from 'react';
import { useApi } from './withApi';

function useApiHealthCheck(policySystem, interval = 30000) {
  const api = useApi();
  const [isOnline, setIsOnline] = useState(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const checkIPXHealt = async () => {
      try {
        const response = await api.getIPXHealthCheck();
        if (response.status === 200) {
          setIsOnline(true);
        } else {
          setIsOnline(false);
        }
      } catch (error) {
        setIsOnline(false);
      }
    };

    const checkVioletHealt = async () => {
      try {
        const response = await api.getVioletHealthCheck();
        if (response.status === 200) {
          setIsOnline(true);
        } else {
          setIsOnline(false);
        }
      } catch (error) {
        setIsOnline(false);
      }
    };

    if (policySystem === 'IPX') {
      checkIPXHealt();
      timeoutRef.current = setInterval(checkIPXHealt, interval);
    }

    if (policySystem === 'Violet') {
      checkVioletHealt();
      timeoutRef.current = setInterval(checkVioletHealt, interval);
    }

    return () => {
      if (timeoutRef.current) {
        clearInterval(timeoutRef.current);
      }
    };
  }, [interval, policySystem]);

  return isOnline;
}

export default useApiHealthCheck;
